var KISTLER = KISTLER || {};

KISTLER.reveals = function() {
	$(document).ready(() => {
		$(".site-header").addClass("reveal");
		$("main").addClass("reveal");
		setTimeout(() => {
			$(".page-pages-home .logo").addClass("reveal");
		}, 2000);
	})
}();

KISTLER.carousels = function() {
	// Instantiate explicitly: without data-ride, Bootstrap only initializes the
	// carousel on arrow/indicator click, so touch swipe listeners never attach.
	$("#fullCarousel").carousel();
	$("#fullCarousel").on('slide.bs.carousel', function () {
		if ($(".carousel-control-prev").length) {
			$(".carousel-control-prev").addClass("started");
		}
	});
}();

KISTLER.mapStuff = function() {
	const img = document.getElementById('map-image');
	if ($(img).length === 0) return;
	const map = $(img).closest('.map');
	const container = $(img).closest('.map-container')[0];

	// --- Initial scroll position ---
	// When the map overflows horizontally (e.g. iPad), center the viewport on
	// the midpoint of the pinned locations so they're all on screen at load.
	function setInitialScroll() {
		if (container.scrollWidth <= container.clientWidth) return;

		const pinXs = $(map).find('.map-pin').map(function() {
			return parseFloat(this.style.left);
		}).get().filter((x) => !isNaN(x));

		const focalX = pinXs.length
			? (Math.min(...pinXs) + Math.max(...pinXs)) / 2
			: 50;

		const target = (container.scrollWidth * focalX / 100) - (container.clientWidth / 2);
		container.scrollLeft = Math.max(0, target);
	}

	if (img.complete) setInitialScroll();
	else img.addEventListener('load', setInitialScroll);

	// --- Coordinate picker ---
	$(img).on('click', (e) => {
		if ($(e.target).closest('.map-pin').length) return;

		const rect = img.getBoundingClientRect();
		const x = ((e.clientX - rect.left) / rect.width * 100).toFixed(2);
		const y = ((e.clientY - rect.top) / rect.height * 100).toFixed(2);
		console.log(`map_coordinates: ${x}, ${y}`);

		const ripple = document.createElement('div');
		ripple.classList.add('map-ripple');
		ripple.style.left = `${x}%`;
		ripple.style.top  = `${y}%`;
		$(map).append(ripple);
		ripple.addEventListener('animationend', () => ripple.remove());
	});
}();

KISTLER.navStuff = function() {
	const burger  = document.querySelector('.burger');
	const drawer  = document.getElementById('mobile-nav-drawer');
	const overlay = document.getElementById('mobile-nav-overlay');

	if (!burger || !drawer || !overlay) return;

	const close   = drawer.querySelector('.mobile-nav-drawer__close');

	function openNav() {
		drawer.classList.add('is-open');
		overlay.classList.add('is-open');
		burger.classList.add('is-open');
		drawer.setAttribute('aria-hidden', 'false');
		overlay.setAttribute('aria-hidden', 'false');
		burger.setAttribute('aria-expanded', 'true');
		document.body.style.overflow = 'hidden';
	}

	function closeNav() {
		drawer.classList.remove('is-open');
		overlay.classList.remove('is-open');
		burger.classList.remove('is-open');
		drawer.setAttribute('aria-hidden', 'true');
		overlay.setAttribute('aria-hidden', 'true');
		burger.setAttribute('aria-expanded', 'false');
		document.body.style.overflow = '';
	}

	burger.addEventListener('click', openNav);
	close.addEventListener('click', closeNav);
	overlay.addEventListener('click', closeNav);

	document.addEventListener('keydown', (e) => {
		if (e.key === 'Escape') closeNav();
	});

	window.addEventListener('resize', () => {
		if (window.innerWidth >= 992) closeNav();
	});
}();